import ToastBar from 'src/components/ToastBar/ToastBar';
import { connect } from 'react-redux';
import { IStoreState } from 'src/store';

const mapStateToProps = (state: IStoreState) => ({
    specData: state.Specs.specs,
    theme: state.Framework.theme,
});

export default connect(
    mapStateToProps,
    null,
)(ToastBar);